import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { mergeMap, map, catchError, of } from "rxjs";
import { SobreService } from "src/app/services/sobre.service";
import { obterSobre, obterSobreSuccess } from "../../actions/Sobre/obter-sobre.action";

@Injectable()
export class ObterSobreEffects {

  public obterSobre$: unknown;

  constructor(private actions$: Actions,
    private SobreService: SobreService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterSobre$ = createEffect(() => this.actions$.pipe(
      ofType(obterSobre),
      mergeMap(() =>
        this.SobreService.obterSobre()
        .pipe(map(response => {
          return obterSobreSuccess({ response });
        }),
          catchError(() => of())
        )
      )
    )
    );
  }
}
